export default __webpack_public_path__ + "static/media/fri-blue.99e10678.png";